export default [
  {
    path: "/ngo-profile",
    component: () =>
      import(/* webpackChunkName: "ngo-profile" */ "./moduleLayout.vue"),
    children: [
      {
        path: "",
        name: "ngo-profile",
        component: () => import("./pages/main/index.vue"),
        meta: {
          pageTitle: "ملف المنظمة",
          slug: "ngo-profile",
          instructionsSlug: "ngo-management",
          breadcrumb: [
            {
              text: "ملف المنظمة",
              active: true,
            },
          ],
        },
      },

      {
        path: "events-log",
        name: "events-log",
        component: () => import("./pages/log-view/index.vue"),
        meta: {
          pageTitle: "سجل التتبع",
          slug: "ngo-profile",
          breadcrumb: [
            {
              text: "ملف المنظمة",
              active: true,
            },
            {
              text: "سجل التتبع",
              active: true,
            },
          ],
        },
      },
      {
        path: "branches-and-departments",
        component: () => import("./pages/branches-and-departments/index.vue"),
        meta: {
          pageTitle: "الفروع و المكاتب",
          slug: "ngo_branches",
          instructionsSlug: "branches-and-departments",

          breadcrumb: [
            {
              text: "ملف المنظمة",
              active: true,
            },
            {
              text: "الفروع و المكاتب",
              active: true,
            },
          ],
        },
      },
      {
        path: "contact-info",
        component: () => import("./pages/contact-info/index.vue"),
        meta: {
          pageTitle: "معلومات التواصل",
          slug: "ngo_contact_information",
          instructionsSlug: "contact-info",

          breadcrumb: [
            {
              text: "ملف المنظمة",
              active: true,
            },
            {
              text: "معلومات التواصل",
              active: true,
            },
          ],
        },
      },
      {
        path: "creation-info",
        component: () => import("./pages/creation-info/index.vue"),
        meta: {
          pageTitle: "معلومات التأسيس",
          slug: "ngo-profile",
          instructionsSlug: "creation-info",

          breadcrumb: [
            {
              text: "ملف المنظمة",
              active: true,
            },
            {
              text: "معلومات التأسيس",
              active: true,
            },
          ],
        },
      },

      {
        path: "ngo-services",
        component: () => import("./pages/ngo-services/index.vue"),
        meta: {
          pageTitle: "خدمات المنظمة",
          slug: "ngo_classifications",
          instructionsSlug: "ngo-services",

          breadcrumb: [
            {
              text: "ملف المنظمة",
              active: true,
            },
            {
              text: "خدمات المنظمة",
              active: true,
            },
          ],
        },
      },
      {
        path: "service-centers",
        component: () => import("./pages/service-centers/index.vue"),
        meta: {
          pageTitle: "المراكز الخدمية",
          slug: "ngo_service_centres",
          instructionsSlug: "service-centers",
          breadcrumb: [
            {
              text: "ملف المنظمة",
              active: true,
            },
            {
              text: "المراكز الخدمية",
              active: true,
            },
          ],
        },
      },
      {
        path: "bank-accounts",
        component: () => import("./pages/bank-accounts/index.vue"),
        meta: {
          pageTitle: "الحسابات البنكية",
          slug: "ngo_bank_accounts",
          instructionsSlug: "bank-accounts",

          breadcrumb: [
            {
              text: "ملف المنظمة",
              active: true,
            },
            {
              text: "الحسابات البنكية",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
